import * as React from 'react';
import { useSiteList } from '@cguard/api-client/hooks/sites';
import { withoutSeededDemoSites } from '~/lib/production-roster';

/** Site names by id for labelling cameras; empty while the site directory loads. */
export function useSiteNames(): ReadonlyMap<string, string> {
  const sites = useSiteList();
  return React.useMemo(
    () => new Map(withoutSeededDemoSites(sites.data ?? []).map((site) => [site.id, site.name])),
    [sites.data],
  );
}
